import {all} from 'redux-saga/effects';
import {authSaga} from './authSaga';
import {employeeSaga} from './empoyeesSaga';
import {projectSaga} from './projectsSaga';
import {projectAnalyticsSaga} from './projectAnalytics';
import {userStorySaga} from './userStorySaga';
import {profileSaga} from './profileSaga';
import {dashboardSaga} from './dashboardSaga';

const rootSaga = function* root() {
  yield all([
    authSaga(),
    projectSaga(),
    employeeSaga(),
    projectAnalyticsSaga(),
    userStorySaga(),
    profileSaga(),
    dashboardSaga(),
  ]);
};

export default rootSaga;
